import Vue from 'vue'
import { S, G, M, A } from './types'
import { Getters, Mutations, Actions } from 'vuex'
import { normalize } from 'normalizr'
import { TeamOnlineStatus } from '@/types/team'
import { onlineStatusSchema } from '@/schema/onlineStatus'
import { TeamOnlineStatusEntities } from '@/schema/onlineStatus/types'

/* -------------------------------------------------------------------------- */

const state = (): S => ({
  onlineStatus: {}
})

/* -------------------------------------------------------------------------- */

const getters: Getters<S, G> = {
  onlineStatus: state => state.onlineStatus
}

/* -------------------------------------------------------------------------- */

const mutations: Mutations<S, M> = {
  setOnlineStatus: (state, onlineStatus) => {
    Object.keys(onlineStatus).forEach(id => {
      Vue.set(state.onlineStatus, id, onlineStatus[Number(id)])
    })
  }
}

/* -------------------------------------------------------------------------- */

const actions: Actions<S, A, G, M> = {
  async fetch({ commit }) {
    const response = await Vue.$api.team.fetchStatus()
    if (response.length === 0) return

    const { entities } = normalize<
      TeamOnlineStatus,
      TeamOnlineStatusEntities,
      number[]
    >(response, [onlineStatusSchema])

    const { onlineStatus } = entities

    commit('setOnlineStatus', onlineStatus)
  }
}

/* -------------------------------------------------------------------------- */

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
